import React, { useState } from 'react';
import { CloseIcon } from '../../../../../base/ui/svg/AmsaleIcons';
import { mobileMenuData } from '../../../../../base/ui/menuData/MenuTree';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';


function MobileMenu({ handleCloseMenu }) {
  const [activeTab, setActiveTab] = useState('ready-to-wear');
  const activeData = mobileMenuData.tabs.find(tab => tab.key === activeTab);
  const { Button } = useUiContext();
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (name) => {
    setExpandedSections((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };


  return (
    <div className="mobile-menu">
      <div className="drawer-inner">
        {/* Header */}
        <div className="drawer-header">
          <Button className="close-button" onClick={handleCloseMenu} aria-label="Close menu">
            <CloseIcon />
          </Button>
        </div>

        {/* Navigation */}
        <nav className="mobile-nav">
          {/* Top tabs */}
          <ul className="mobile-tabs">
            {mobileMenuData.tabs.map(tab => (
              <li key={tab.key}>
                <button
                  className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.name}
                </button>
              </li>
            ))}
          </ul>

          {/* Tab content */}
          <ul className="tab-content">
            {activeData.sections.map((item) => {
              const hasChildren = item.children && item.children.length > 0;
              const isExpanded = expandedSections[item.name];

              return (
                <li key={item.name} className="tab-content-item">
                  {hasChildren ? (
                    <>
                      <button
                        className="tab-link parent-label dropdown-toggle"
                        onClick={() => toggleSection(item.name)}
                        aria-expanded={isExpanded}
                      >
                        {item.name}
                        <span className={`dropdown-arrow ${isExpanded ? 'open' : ''}`}>&#9662;</span>
                      </button>
                      {isExpanded && (
                        <ul className="child-list">
                          {item.children.map((child) => (
                            <li key={child.name}>
                              <a href={child.url} className="tab-link child-link">
                                {child.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </>
                  ) : (
                    <a href={item.url} className="tab-link">
                      {item.name}
                    </a>
                  )}
                </li>
              );
            })}
          </ul>



          {/* Bottom links at bottom of drawer */}
          <ul className="bottom-links">
            {mobileMenuData.bottomLinks.map((item) => (
              <li key={item.name}>
                <a href={item.url} className="tab-link">
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default MobileMenu;
